<template>
  <div v-if="canSee && vehicle && vehicle.customer">
    <!-- Le véhicule d'un client membre de plusieurs organisations : on choisit pour laquelle on commande. -->
    <v-select
        v-if="members.length > 1"
        v-model="memberId"
        :items="memberChoices"
        :label="$t('onboarding.commissioning.vehicle.member')"
        outlined dense hide-details class="mb-3"
        style="max-width: 420px"
    />
    <equipment-orders-card
        :organization-id="organizationId"
        :title="$t('onboarding.commissioning.vehicle.title')"
        :query="query"
        :matches="isOfVehicle"
        holder="member"
        :member="member"
        :vehicle="vehicle"
        :kinds="vehicleKinds"
        :blocked-reason="loaded && !member ? $t('onboarding.commissioning.vehicle.no-member') : null"
    />
  </div>
</template>

<script>
import MemberRepository from '@repository/MemberRepository'
import { VEHICLE_KINDS } from '../CommissioningMixin'
import EquipmentOrdersCard from './EquipmentOrdersCard.vue'

/**
 * Sur la fiche d'un véhicule : ses commandes (véhicule connecté, véhicule compteur) et le bouton pour
 * en passer une. Elle est pour le membre propriétaire — le membre de l'organisation dont le client
 * est celui du véhicule —, et désigne ce véhicule.
 */
export default {
  name: 'VehicleEquipmentOrders',

  components: { EquipmentOrdersCard },

  props: {
    vehicle: { type: Object, required: true },
  },

  data() {
    return { members: [], memberId: null, loaded: false }
  },

  computed: {
    canSee() {
      const permissions = this.currentUser?.permissions || []
      return permissions.includes('COMMISSIONING_REQUEST') || permissions.includes('ONBOARDING_MODULE_MANAGE')
    },
    vehicleKinds() {
      return VEHICLE_KINDS
    },
    member() {
      return this.members.find(m => m.id === this.memberId) || null
    },
    organizationId() {
      return this.member?.organization?.id || this.vehicle?.organization?.id || null
    },
    memberChoices() {
      return this.members.map(m => ({ value: m.id, text: m.organization?.name || m.id }))
    },
    query() {
      return { holder: 'member', search: this.member?.customer?.email || this.vehicle?.customer?.email || null }
    },
  },

  watch: {
    'vehicle.id': {
      immediate: true,
      handler() {
        this.loadMembers()
      },
    },
  },

  methods: {
    /** Le membre propriétaire : le client du véhicule, dans l'organisation du véhicule si elle est connue. */
    async loadMembers() {
      this.loaded = false
      this.members = []
      this.memberId = null
      const customerId = this.vehicle?.customer?.id
      if (!customerId || !this.canSee) {
        return
      }
      try {
        const search = { customerId, offset: 0, limit: 20 }
        if (this.vehicle.organization?.id) search.organizationId = this.vehicle.organization.id
        const result = await MemberRepository.search(search, 'vehicle-equipment-orders')
        this.members = result.items || []
        this.memberId = this.members[0]?.id || null
      } catch (e) {
        this.members = []
      } finally {
        this.loaded = true
      }
    },

    isOfVehicle(order) {
      return order.vehicleId === this.vehicle.id || order.preparedEquipmentId === this.vehicle.id
    },
  },
}
</script>
